import React from 'react';
import { IconCoins } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const Currencies = () => (
    <SimpleLookupCrud
        icon={IconCoins}
        gradient="amber"
        title="Moedas"
        subtitle="Moedas usadas em vendas, compras e financeiro"
        endpoint="currencies"
        addLabel="Nova moeda"
        columns={[
            { key: 'code', label: 'Código', type: 'text', required: true },
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'symbol', label: 'Símbolo', type: 'text' }
        ]}
    />
);

export default Currencies;
